export default __webpack_public_path__ + "static/media/guide.3c4e5df5.png";